import { useEffect } from "react";
import { Navigate } from "react-router-dom";

// The single form now lives on the home page (`#contato-rapido`).
// Any incoming link to /contato is redirected there.
const ContactPage = () => {
  useEffect(() => {
    // Smooth scroll happens automatically via the hash after navigation
  }, []);
  return <Navigate to="/#contato-rapido" replace />;
};

export default ContactPage;
